import React from 'react';
import Icon from '../../../components/AppIcon';

const RetentionStrategiesPanel = ({ strategies, loading }) => {
  const getPriorityColor = (priority) => {
    const colorMap = {
      high: 'bg-error/10 text-error',
      medium: 'bg-warning/10 text-warning',
      low: 'bg-primary/10 text-primary'
    };
    return colorMap?.[priority] || 'bg-primary/10 text-primary';
  };

  const getPriorityIcon = (priority) => {
    const iconMap = {
      high: 'AlertCircle',
      medium: 'AlertTriangle',
      low: 'Info'
    };
    return iconMap?.[priority] || 'Info';
  };

  if (loading) {
    return (
      <div className="card">
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center">
          <Icon name="Target" size={20} color="var(--color-accent)" />
        </div>
        <div>
          <h3 className="text-xl font-heading font-semibold text-foreground">
            AI-Powered Retention Strategies
          </h3>
          <p className="text-sm text-muted-foreground">
            {strategies?.length || 0} strategies recommended
          </p>
        </div>
      </div>

      <div className="space-y-4">
        {strategies?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="Sparkles" size={48} color="var(--color-accent)" className="mx-auto mb-3" />
            <p className="text-muted-foreground">Generate AI insights to see retention strategies</p>
          </div>
        ) : (
          strategies?.map((strategy, index) => (
            <div
              key={index}
              className="bg-muted/50 rounded-lg p-5 hover:bg-muted transition-colors duration-250"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-8 h-8 rounded-lg bg-card flex items-center justify-center flex-shrink-0">
                  <Icon name={getPriorityIcon(strategy?.priority)} size={16} color="var(--color-accent)" />
                </div>
                <div className="flex-1">
                  <div className="flex items-start justify-between gap-2 mb-2">
                    <h4 className="font-semibold text-foreground">{strategy?.strategy}</h4>
                    <span className={`px-2 py-1 rounded text-xs font-medium ${getPriorityColor(strategy?.priority)}`}>
                      {strategy?.priority?.toUpperCase()}
                    </span>
                  </div>
                  <p className="text-sm text-muted-foreground mb-3">
                    <span className="font-medium">Target:</span> {strategy?.targetSegment}
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                    <div className="bg-card rounded-lg p-3">
                      <p className="text-xs text-muted-foreground mb-1">Expected Impact</p>
                      <p className="text-sm font-medium text-success">{strategy?.expectedImpact}</p>
                    </div>
                    {strategy?.implementation && (
                      <div className="bg-card rounded-lg p-3">
                        <p className="text-xs text-muted-foreground mb-1">Implementation</p>
                        <p className="text-sm font-medium text-foreground">{strategy?.implementation}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RetentionStrategiesPanel;